import { isEmpty } from "lodash";
import { FIELD_TYPES } from "./constants";

const addKeyIfExists = (obj, key, targetObj) => {
    if (obj[key]) {
        if (targetObj[key]) {
            targetObj[key] = targetObj[key].concat(obj[key]);
        } else {
            targetObj[key] = [obj[key]];
        }
    } else {
        if (targetObj[key]) {
            targetObj[key] = targetObj[key].concat(null);
        } else {
            targetObj[key] = [null];
        }
    }
};

const trimValues = (object) => {
    let _values = {};
    if (object) {
        Object.keys(object).forEach((key) => {
            if (!isEmpty(object[key])) {
                _values[key] = object[key].trim() ? object[key] : null;
            }
        });
    }
    return _values;
};

const classNames = (...args) => {
    return args.filter(Boolean).join(" ");
};

const objectValuesFromNumbersToString = (object) => {
    if (typeof object !== "object" || isEmpty(object)) return {};
    Object.keys(object).forEach((k) => {
        if (typeof object[k] === "object") {
            return toString(object[k]);
        }
    });
    return object;
};

const getEnvironment = () => {
    const baseURL = process.env.REACT_APP_API_URL.replace("https://", "");
    const splittedURL = baseURL.split(".");
    return splittedURL.length > 2 ? splittedURL[0] : "dev";
};

const removeUnchangedProps = (existingData, newData, skipProps = []) => {
    const modifiedData = { ...newData };
    Object.keys(newData).forEach((key) => {
        if (modifiedData[key] === existingData[key] && !skipProps.includes(key))
            delete modifiedData[key];
    });
    return modifiedData;
};

const splitValueUnit = (param) => {
    let value;
    if (param && (typeof param === "string" || param instanceof String)) {
        const unit =
            param
                .trim()
                .split(/\d+/g)
                .filter((n) => n)
                .pop()
                ?.trim() || null;
        if (unit) {
            value = param
                .trim()
                .split(unit)
                .filter((n) => n)[0]
                ?.trim();
        }
    }
    return value || param || 0;
};

const toCamelCase = (str) => {
    return (
        str &&
        str
            .replace(/\s(.)/g, (a) => {
                return a.toUpperCase();
            })
            .replace(/\s/g, "")
            .replace(/^(.)/, (b) => {
                return b.toLowerCase();
            })
    );
};

const formResetHandler = (fields) => {
    const fieldsObj = {};
    const newInputObj = {};
    fields.map((elem) => (fieldsObj[elem.name] = elem));

    Object.keys(fieldsObj).map((key) => {
        if (!fieldsObj[key]?.role) {
            const type = fieldsObj[key].type;
            switch (type) {
                case FIELD_TYPES.Input:
                    newInputObj[key] = "";
                    return;
                case FIELD_TYPES.Dropdown:
                    newInputObj[key] = fieldsObj[key].isMulti ? [] : null;
                    return;
                default:
                    newInputObj[key] = null;
                    return;
            }
        }
    });
    return newInputObj;
};

const toBemCase = (str) => {
    if (str) {
        if (str.includes(" ")) return str.replace(" ", "-")?.toLowerCase();
        // converting to bem-case from camelCase
        else return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
    }
};

//capitalize only the first letter of the string.
const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};
//capitalize all words of a string.
const capitalizeWords = (string) => {
    if (!string) return;
    return string.replace(/(?:^|\s)\S/g, (a) => a.toUpperCase());
};

const mapLookupToSelect = (data, nameAccessor = "name", idAccessor = "id") => {
    return data?.map((record) => ({
        value: record[idAccessor],
        label: record[nameAccessor],
    }));
};

const stringifyIfNumber = (val) => {
    return typeof val === "number" ? val.toString() : val;
};

const getEncodedValue = (name) => {
    return name?.replaceAll("%", "__percent_sign__");
};

const getNameWithoutExtension = (fileName) => {
    return fileName?.substring(0, fileName?.lastIndexOf("."));
};

const validateEmail = (email) => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
};

export {
    addKeyIfExists,
    trimValues,
    getEnvironment,
    classNames,
    splitValueUnit,
    objectValuesFromNumbersToString,
    removeUnchangedProps,
    toCamelCase,
    toBemCase,
    capitalizeFirstLetter,
    capitalizeWords,
    mapLookupToSelect,
    stringifyIfNumber,
    getEncodedValue,
    getNameWithoutExtension,
    formResetHandler,
    validateEmail,
};
